module.exports = __webpack_public_path__ + "img/Icon-social-facebook.d2dd4611.svg";